export const formInputNames = {
  jobName: 'job_name',
  jobNumber: 'job_number',
  jobDescription: 'job_description',
  jobStart: 'job_start',
  jobEnd: 'job_end',
  status: 'status',
  ownerId: 'owner_id',
  departmentId: 'department_id',
  projectRequirementTemplate: 'project_requirement_template'
};
